import { connect } from 'react-redux';

import DashboardPage from '../components/DashboardPage/DashboardPage';

const mapStateToProps = state => ({
  organisation: state.organisations.organisation
});

export default connect(mapStateToProps)(DashboardPage);
